import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { bankInfoType } from "../../../common/interfaces/myProfile/personalDetails/bankInfoType";
// Define a type for the slice state

// Define the initial state using that type

// const initialState: bankInfoType = {
//   accountName: "",
//   accountNo: 0,
//   bankName: "",
//   IBAN: "",
//   MOL: "",
//   UAN: "",
//   ifsc: "",
//   routing_number: "",
// };

const bankInfoSlice = createSlice({
  name: "bankInformation",

  initialState: { bank_details: [] },
  reducers: {
    getBankInfoReducer: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.bank_details = payload;
    },
    resetBankInfo: (state: any) => {
      state.bank_details = [];
    },
  },
});

export const { getBankInfoReducer, resetBankInfo } = bankInfoSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default bankInfoSlice.reducer;
